export default __webpack_public_path__ + "static/media/logo_header.bdd30704.png";